import {AfterViewInit, Directive, ElementRef, inject, input} from '@angular/core';
import {pattern, FormatterService} from '@xmedical/core';

@Directive({
    selector: '[xuiInputFormatter]',
    host: {
      '(blur)': 'blur()',
      '(keyup)': 'keyUpHandler()',
      '(paste)': 'paste()'
    }
})
export class InputFormatterDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private formatter = inject(FormatterService);

  readonly formatPattern = input<pattern>('default');

  ngAfterViewInit(): void {
    this.format();
  }

  blur() {
    this.format();
  }
  keyUpHandler() {
    this.format();
  }

  paste() {
    this.format();
  }

  private format() {
    this.elementRef.nativeElement.value = this.formatter.format(this.elementRef.nativeElement.value, this.formatPattern());
  }
}
